import React, { useState, useEffect } from 'react'
import ArticleCard from '/react4xp/components/ArticleCard'
import Button from '/react4xp/components/Button'

interface ArticleCardProps {
   title: string,
   isHighlighted?: boolean,
   img?: {
      src?: string,
      srcMobile?: string,
      alt?: string,
   },
   url: string,
   badges?: {
      insights?: boolean,
      news?: boolean,
   },
   customBadges?: string[],
}

interface Props {
   title: string,
   highlightedCard?: ArticleCardProps,
   cards: ArticleCardProps[],
   cta?: {
      label: string,
      url: string,
      isExternal?: boolean,
   }
   isPrototype?: boolean,
}

export default function ArticleList(props: Props) {
   const { title, highlightedCard, cards, cta } = props

   return (
      <div className='article-list'>
         <div className="grid-container">
            <div className="article-list__wrapper">
               {title &&
                  <div className="grid-row">
                     <div className="c-12">
                        <h1 className='article-list__title'>{title}</h1>
                     </div>
                  </div>
               }
               {highlightedCard &&
                  <div className="article-list__highlight">
                     <ArticleCard {...highlightedCard} />
                  </div>
               }
               {cards.length !== 0 &&
                  <div className="article-list__cards">
                     <div className="grid-row">
                        {cards.map((card, index) => (
                           <div className="c-sm-4 c-xs-6" key={index}>
                              <ArticleCard key={index} {...card} />
                           </div>
                        ))}
                     </div>
                  </div>
               }
               {cta &&
                  <div className="article-list__cta">
                     <Button href={cta.url} target={cta.isExternal} size='sm' className='btn btn--primary' rightIcon='ArrowRight'>
                        {cta.label}
                     </Button>
                  </div>
               }
            </div>
         </div>
      </div>
   )
}